export const getAmountWithVat = (num: number) => num * 1.22;

export const roundHundred = (num: number) => Math.round(num / 100) * 100;
